import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section id="garantia" className="bg-forest-900 px-5 py-12 sm:py-20" data-id="element-99" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto flex max-w-4xl flex-col items-center gap-5 text-center md:flex-row md:gap-8 md:text-left" data-id="element-100" data-mp="1o5zqy212ub4m">
        <div className="flex h-20 w-20 shrink-0 flex-col items-center justify-center rounded-full border-[3px] border-gold-400 bg-forest-950 text-gold-400 sm:h-32 sm:w-32 sm:border-4" data-id="element-101" data-mp="1x4lao0iabw6z">
          <ShieldCheckIcon className="h-5 w-5 sm:h-8 sm:w-8" aria-hidden="true" data-id="element-102" data-mp="14fo3otjixltj" />
          <span className="mt-0.5 font-display text-sm leading-none sm:mt-1 sm:text-lg" style={{
          fontWeight: 700
        }} data-id="element-103" data-mp="14dl4pk0e8ico">
            7 DÍAS
          </span>
          <span className="mt-0.5 text-[0.45rem] font-bold uppercase tracking-[0.12em] sm:mt-1 sm:text-[0.6rem] sm:tracking-[0.15em]" data-id="element-104" data-mp="1ecsputdddhac">
            Garantía total
          </span>
        </div>
        <div data-id="element-105" data-mp="lpy6jzsagnyg">
          <h2 className="font-display text-[1.5rem] leading-tight text-cream-50 sm:text-4xl" style={{
          fontWeight: 700
        }} data-id="element-106" data-mp="lodd6dhpnb26">
            7 días para probarlo o te devolvemos el 100%
          </h2>
          <p className="mt-2.5 text-[0.85rem] leading-relaxed text-cream-200 sm:mt-4 sm:text-base" data-id="element-107" data-mp="twi42y3xd9l8">
            Aplicás el ritual de salida, empezás el protocolo, usás las planillas. Si no es lo que esperabas:
            sin preguntas, sin formularios, sin drama.
          </p>
        </div>
      </div>
    </section>;
}